/* eslint-disable react-hooks/exhaustive-deps */
import { FC, useEffect, useState } from "react";
import "./PaymentHistoryDetailScreen.css";
import backIcon from "../../../assets/images/back-icon.svg";
import coinIcon from "../../../assets/images/credit-paln-coins-icon.svg";
import orangeStarIcon from "../../../assets/images/membership-orange-star.svg";
import paymentStarIcon from "../../../assets/images/communicate-star-icon.svg";
import downloadInvoiceIcon from "../../../assets/images/payment-history-download-invoice-icon.svg";
import { useNavigate } from "react-router-dom";
import { PAYMENT_HISTORY_FORMAT } from "utils/constants";
import dayjs from "dayjs";
import { getUrls } from "utils/urls";
import { STORAGE_KEY } from "utils/strings";

const PaymentHistoryDetailScreen: FC = () => {
  const navigate = useNavigate();
  const URLS = getUrls();
  const [selectedPaymentData, setSelectedPaymentData] = useState<any>(null);
  const [paymentEndDate, setPaymentEndDate] = useState<any>(null);

  useEffect(() => {
    const storedData = localStorage.getItem(
      STORAGE_KEY.SELECTED_PAYMENT_HISTORY_DATA,
    );
    if (storedData) {
      const parsedData = JSON.parse(storedData);
      setSelectedPaymentData(parsedData);
      const endDate = new Date();
      endDate.setMonth(endDate.getMonth() + (parsedData?.validity || 0));
      setPaymentEndDate(endDate);
    }
  }, []);

  const handleBackButtonClick = () => {
    navigate(-1);
  };

  const handlePaymentDownload = () => {
    window.open(
      URLS.DOWNLOAD_INVOICE(selectedPaymentData?.payment_id),
      "_blank",
    );
  };

  const getScreenHeader = () => {
    if (selectedPaymentData?.slot_id) {
      return "Event";
    } else {
      return selectedPaymentData?.product_name;
    }
  };

  return (
    <div className="wms-mobile-container">
      <div className="payment-history-detail-screen-container">
        <div className="payment-history-detail-header-container">
          <img
            src={backIcon}
            alt="dropdown-logo"
            className="image"
            onClick={handleBackButtonClick}
          />
          <div className="left-container">
            <div className="title">{getScreenHeader()}</div>
          </div>
        </div>
        <div className="payment-history-detail-content-container">
          <span>Credit</span>
          <div className="divider"></div>
          <div className="sub-container">
            <div>
              <img src={orangeStarIcon} alt="orange-star-icon" />
              <span className="title">
                INR {selectedPaymentData?.price?.toLocaleString("en-US")}
              </span>
            </div>
            <div className="credit_container">
              <img src={coinIcon} alt="profile-coin-icon" />
              {selectedPaymentData?.credit} Credits
            </div>
          </div>
          {selectedPaymentData?.validity && (
            <>
              <span>Validity</span>
              <div className="divider"></div>
              <div className="sub-container">
                <div>
                  <img src={orangeStarIcon} alt="orange-star-icon" />
                  <span className="validity_title">
                    {selectedPaymentData?.validity} Months
                  </span>
                </div>
                <span className="validity_title">
                  <span className="validity_title" style={{ color: "#c2b58c" }}>
                    Up-To
                  </span>{" "}
                  {dayjs(paymentEndDate).format(PAYMENT_HISTORY_FORMAT)}
                </span>
              </div>
            </>
          )}
          <div className="payment-history-detail-download-invoice-container">
            <span>Order Summary</span>
            <img
              src={downloadInvoiceIcon}
              alt="download-invoice-icon"
              onClick={handlePaymentDownload}
            />
          </div>
          <div className="divider"></div>
          <div className="order-container">
            <div>
              <img src={paymentStarIcon} alt="payment-star-icon" />
              <span className="order_title">Price</span>
            </div>
            <span className="order_title">
              INR{" "}
              {Math.floor(selectedPaymentData?.price)?.toLocaleString("en-US")}
            </span>
          </div>
          {selectedPaymentData?.discounted_price && (
            <div className="order-container">
              <div>
                <img src={paymentStarIcon} alt="payment-star-icon" />
                <span className="order_title bold">Discount</span>
              </div>
              <span className="order_title bold">
                INR{" "}
                {Math.floor(
                  selectedPaymentData?.discounted_price,
                )?.toLocaleString("en-US")}
              </span>
            </div>
          )}
          <div className="sub-divider"></div>
          {selectedPaymentData?.sub_total_price && (
            <div className="order-container">
              <div>
                <img src={paymentStarIcon} alt="payment-star-icon" />
                <span className="order_title">Sub Total</span>
              </div>
              <span className="order_title">
                INR{" "}
                {Math.floor(
                  selectedPaymentData?.sub_total_price,
                )?.toLocaleString("en-US")}
              </span>
            </div>
          )}
          <div className="order-container">
            <div>
              <img src={paymentStarIcon} alt="payment-star-icon" />
              <span className="order_title bold">GST</span>
            </div>
            <span className="order_title bold">
              INR{" "}
              {Math.floor(selectedPaymentData?.with_gst_price)?.toLocaleString(
                "en-US",
              )}
            </span>
          </div>
          <div className="bottom-divider"></div>
          <div className="order-container">
            <span className="order-total">Total Paid</span>
            <span className="order-total">
              INR{" "}
              {Math.floor(selectedPaymentData?.total_price)?.toLocaleString(
                "en-US",
              )}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentHistoryDetailScreen;
